import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Buffer } from 'buffer';
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";
import { TrackingLane } from '../../model/iTrackingLane';

@Injectable({
  providedIn: 'root'
})
export class TrackingLaneService {
  http = inject(HttpClient)

  getTrackingLanes(): Observable<any> {
    return this.http.get(`${environment.yomaApiURL}/tracking_lanes`);
  }

  newTrackingLane(name: string): Observable<any> {
    return this.http.post(`${environment.yomaApiURL}/tracking_lanes`, null, { params: { name } });
  }

  getTrackingLane(id: string): Observable<any> {
    const encoded = Buffer.from(id).toString('base64');
    return this.http.get(`${environment.yomaApiURL}/tracking_lanes/${encoded}`);
  }

  updateTrackingLane(payload: TrackingLane): Observable<any> {
    const encoded = Buffer.from(payload.id!).toString('base64');
    delete payload.id;
    delete payload.created_at;
    
    return this.http.put(`${environment.yomaApiURL}/tracking_lanes/${encoded}`, payload);
  }

  deleteTrackingLane(id: string): Observable<any> {
    const encoded = Buffer.from(id).toString('base64');
    return this.http.delete(`${environment.yomaApiURL}/tracking_lanes/${encoded}`);
  }

}
